import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const SubmitStorePickupPackageList = (data: any) =>
    request({
        url: ApiURL.Command.SubmitStorePickupPackageList,
        method: RequestType.POST,
        data,
    });

const PrintReport = (data: any) =>
    request({
        url: ApiURL.Command.PrintReport,
        method: RequestType.POST,
        data,
        responseType: 'blob',
    });

const GetReportHistory = (data: any) =>
    request({
        url: ApiURL.Command.GetReportHistory,
        method: RequestType.POST,
        data,
    });

const GenerateStorePickupMessage = (data: any) =>
    request({
        url: ApiURL.Command.GenerateStorePickupMessage,
        method: RequestType.POST,
        data,
    });

const MarkDPackageShipmentMissing = (data: {
    dPackageCargoShipmentCode: string;
    storeCode: string;
    shipmentNumber: string;
    operatorId: number;
}) =>
    request({
        url: ApiURL.Command.MarkDPackageShipmentMissing,
        method: RequestType.POST,
        data,
    });

const StorePickupPackageCommand = {
    SubmitStorePickupPackageList,
    PrintReport,
    GetReportHistory,
    GenerateStorePickupMessage,
    MarkDPackageShipmentMissing,
};

export default StorePickupPackageCommand;
